import request from "@/utils/request";

export function getRegions(params) {
  return request({
    url: `/regions/`,
    method: `get`,
    params,
  });
}

export function getRegionId(id, params) {
  return request({
    url: `/regions/${id}/`,
    method: `get`,
    params,
  });
}

export function postRegions(data) {
  return request({
    url: `/regions/`,
    method: `post`,
    data,
  });
}

export function putRegion(id, data) {
  return request({
    url: `/regions/${id}/`,
    method: `put`,
    data,
  });
}

export function postIsGlodalRegion(id) {
  return request({
    url: `/regions/${id}/global/`,
    method: `post`,
  });
}

export function deleteRegions(id) {
  return request({
    url: `/regions/${id}/`,
    method: `delete`,
  });
}

export function getMacroregions(params) {
  return request({
    url: `/macroregions/`,
    method: `get`,
    params,
  });
}

export function getMacroregionId(id, params) {
  return request({
    url: `/macroregions/${id}/`,
    method: `get`,
    params,
  });
}

export function postMacroregions(data) {
  return request({
    url: `/macroregions/`,
    method: `post`,
    data,
  });
}

export function putMacroregion(id, data) {
  return request({
    url: `/macroregions/${id}/`,
    method: `put`,
    data,
  });
}

export function deleteMacroregion(id) {
  return request({
    url: `/macroregions/${id}/`,
    method: `delete`,
  });
}
